import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ToolTip from '../../components/Tooltip/Tooltip';
import EvolutionTable from './components/EvolutionTable';
import GastosMonto from './components/GastosMonto';
import LineChartCore from './components/LineChartCore';
import Reportes from './components/Reportes';
import classes from './CoreNegocio.module.css';

const CoreNegocio = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, day].join('-');
		return dateFormat.toString();
	}

	const firstDateFilter = new Date();
	const date1 = formatDate(firstDateFilter.setMonth(firstDateFilter.getMonth() - 12));

	const secondDateFilter = new Date();
	const date2 = formatDate(secondDateFilter.setMonth(secondDateFilter.getMonth() - 1));

	//Filters
	const [country, setCountry] = useState('Todos');
	const [clasificacion, setClasificacion] = useState(0);
	const [initialDate, setInitialDate] = useState(date1);
	const [endDate, setEndDate] = useState(date2);

	//Apis
	//const [gastosUrl, setGastosUrl] = useState(`/getGastosByMonth?dateFrom=${initialDate}&dateTo=${endDate}`);
	const [reportsUrl, setReportsUrl] = useState(`/getReportsByMonth?dateFrom=${initialDate}&dateTo=${endDate}`);
	const [usersUrl, setUsersUrl] = useState(`/getUsersEmpresasByMonth?dateFrom=${initialDate}&dateTo=${endDate}`);
	const [empresasUrl, setEmpresasUrl] = useState(`/getEmpresasNuevasByMonth?dateFrom=${initialDate}&dateTo=${endDate}`);
	const [compareReportsUrl, setCompareReportsUrl] = useState(`/compareMontoReportsMonth?dateFrom=${initialDate}&dateTo=${endDate}`);

	//Data
	//const [gastos, setDataGastos] = useState([]);
	const [reports, setDataReports] = useState([]);
	const [users, setDataUsers] = useState([]);
	const [empresas, setDataEmpresas] = useState([]);
	const [compareReports, setDataCompareReports] = useState([]);

	//Aux
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	//Evaluar si conviene cada carga segun un useEffect

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			Axios.all([Axios.get(reportsUrl), Axios.get(usersUrl), Axios.get(empresasUrl), Axios.get(compareReportsUrl)]).then(
				Axios.spread((obj1, obj2, obj3, obj4) => {
					try {
						setDataReports(obj1.data);
						setDataUsers(obj2.data);
						setDataEmpresas(obj3.data);
						setDataCompareReports(obj4.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData();
	}, [reportsUrl, empresasUrl, usersUrl, compareReportsUrl]);

	return (
		<Fragment>
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								//setGastosUrl(`/getGastosByMonth?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`);
								setReportsUrl(
									`/getReportsByMonth?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`,
								);
								setUsersUrl(
									`/getUsersEmpresasByMonth?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`,
								);
								setEmpresasUrl(
									`/getEmpresasNuevasByMonth?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`,
								);
								setCompareReportsUrl(
									`/compareMontoReportsMonth?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`,
								);

								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={country} onChange={(event) => setCountry(event.target.value)}>
										<option value={'Todos'}>Todos los Países</option>
										<option value={'Chile'}>Chile</option>
										<option value={'Peru'}>Peru</option>
										<option value={'Argentina'}>Argentina</option>
										<option value={'Mexico'}>Mexico</option>
										<option value={'Colombia'}>Colombia</option>
									</select>
								</div>

								<div>
									<select value={clasificacion} onChange={(event) => setClasificacion(event.target.value)}>
										<option value={'0'}>Pyme y Corp</option>
										<option value={'1'}>Pyme</option>
										<option value={'2'}>Corp</option>
									</select>
								</div>

								<div>
									<input type="date" id="dateDesde" value={initialDate} onChange={(event) => setInitialDate(event.target.value)} />
								</div>

								<div>
									<input type="date" id="dateHasta" defaultValue={endDate} onChange={(event) => setEndDate(event.target.value)} />
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						<div className={classes.cardNumber}>
							<ToolTip text={'Número de reportes cerrados y aprobados.'} />
							<Reportes compareReports={compareReports} isLoading={isLoading} />
						</div>
					</Grid>
					<Grid item xs={6}>
						<div className={classes.cardNumber}>
							<ToolTip text={'Monto de gastos en USD pertenecientes a informes cerrados y aprobados.'} />

							<GastosMonto compareReports={compareReports} pais={country} isLoading={isLoading} />
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 2 */}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<div className={classes.barChartVentas}>
								<LineChartCore empresas={empresas} reports={reports} users={users} isLoading={isLoading} />
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* SECCIÓN 1 */}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<div className={classes.headerTitle}>Tabla Evolutiva</div>
							<EvolutionTable empresas={empresas} reports={reports} users={users} isLoading={isLoading} />
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(CoreNegocio, Axios);
